import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";
import { queryOptions } from "@tanstack/react-query";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:3000",
  plugins: [
    inferAdditionalFields({
      user: {
        discordId: {
          type: "string",
          required: false,
        },
        discordUsername: {
          type: "string",
          required: false,
        },
        isAdmin: {
          type: "boolean",
          required: false,
        },
      },
    }),
  ],
});

export const { signIn, signOut } = authClient;

export const sessionQueryOptions = queryOptions({
  queryKey: ["session"],
  queryFn: () => authClient.getSession(),
  select: (data) => data?.data,
  retry: false,
});
